import React from 'react'
import Main from '../components/mainpage/Main'

export default function LandingPage() {
  return (
    <Main />
  )
}
